"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactsBlock = void 0;
var Block_1 = require("modules/Block");
var Initializer_1 = require("modules/Initializer");
var FactsBlock_hbs_1 = __importDefault(require("./FactsBlock.hbs"));
require("./facts-block.scss");
var FactsBlock = (function (_super) {
    __extends(FactsBlock, _super);
    function FactsBlock() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.selectLabel = null;
        _this.selectToggle = null;
        _this.selectOptions = [];
        _this.metricsWrapper = null;
        _this.handleToggleChange = function () {
            var _a;
            if ((_a = _this.selectToggle) === null || _a === void 0 ? void 0 : _a.checked) {
                document.addEventListener('click', _this.handleClickOutsideDropdown);
            }
            else {
                document.removeEventListener('click', _this.handleClickOutsideDropdown);
            }
        };
        _this.handleClickOutsideDropdown = function (e) {
            e.stopPropagation();
            var toggle = _this.rootElement.querySelector('.dropdown__switch');
            var targetElement = e.target;
            if (!toggle || targetElement === toggle)
                return;
            var isDropdownChild = targetElement.closest('.dropdown');
            if (!isDropdownChild) {
                toggle.checked = false;
            }
        };
        _this.handleOptionClick = function (e) {
            e.stopPropagation();
            var option = e.currentTarget;
            if (!_this.selectLabel || !(option instanceof HTMLElement))
                return;
            _this.selectLabel.textContent = option.textContent;
            var dataset = option.dataset;
            if (dataset) {
                _this.renderData(dataset);
            }
        };
        return _this;
    }
    FactsBlock.prototype.init = function () {
        this.metricsWrapper = this.rootElement.querySelector(".metric-wrapper");
        this.initSelect();
        this.setBackgroundImage();
    };
    FactsBlock.prototype.setBackgroundImage = function () {
        var _a;
        var backgroundImageUrl = (_a = this.rootElement.querySelector("img")) === null || _a === void 0 ? void 0 : _a.getAttribute("src");
        if (backgroundImageUrl) {
            this.rootElement.style.backgroundImage = "url(".concat(backgroundImageUrl, ")");
        }
    };
    FactsBlock.prototype.initSelect = function () {
        var _this = this;
        this.selectLabel = this.rootElement.querySelector('.dropdown__filter-selected');
        this.selectToggle = this.rootElement.querySelector('.dropdown__switch');
        this.selectOptions = Array.from(this.rootElement.querySelectorAll('.dropdown__select-option'));
        if (!this.selectToggle)
            return;
        this.selectToggle.addEventListener("change", this.handleToggleChange);
        this.selectOptions.forEach(function (option) {
            option.addEventListener('click', _this.handleOptionClick);
        });
    };
    FactsBlock.prototype.renderData = function (dataset) {
        var parseData = function (data) {
            var _a = __read((data === null || data === void 0 ? void 0 : data.split(",")) || [], 2), _b = _a[0], label = _b === void 0 ? "" : _b, _c = _a[1], metric = _c === void 0 ? "" : _c;
            return { label: label, metric: metric };
        };
        var set1 = parseData(dataset.set1);
        var set2 = parseData(dataset.set2);
        var set3 = parseData(dataset.set3);
        var templateData = {
            Label1: set1.label,
            Metric1: set1.metric,
            Label2: set2.label,
            Metric2: set2.metric,
            Label3: set3.label,
            Metric3: set3.metric,
        };
        if (!this.metricsWrapper)
            return;
        this.metricsWrapper.innerHTML = (0, FactsBlock_hbs_1.default)(templateData);
    };
    return FactsBlock;
}(Block_1.Block));
exports.FactsBlock = FactsBlock;
Initializer_1.Initializer.initBlock(".js-facts-block", FactsBlock);
